import axios from 'axios'

export default class PracticeDataServiceClient {
  constructor (practiceUuid) {
    this.client = axios.create({
      baseURL: process.env.VUE_APP_PRACTICE_DATA_SERVICE_DOMAIN,
      headers: {
        'x-api-key': process.env.VUE_APP_PRACTICE_DATA_SERVICE_API_KEY,
        'pp-api-auth-token': process.env.VUE_APP_PRACTICE_DATA_SERVICE_AUTH_TOKEN,
        'pp-auth-strategy': 'service',
        'pp-service-name': 'visit-telehealth-ui',
        'service-name': 'visit-telehealth-ui', // TODO: Remove
        'pp-practice-uuid': practiceUuid,
        'practice-uuid': practiceUuid // TODO: Remove
      }
    })
  }

  getPractice (practiceUuid) {
    return this.client.get(`/v1/practices/${practiceUuid}`)
  }
}
